import React from 'react';
import useActionItemContext from './useActionItemContext.jsx';
import Confirmation from '../Confirmation.jsx';

export default function ActionConfirmation(props) {
  const { clicked, onClose } = useActionItemContext(props);

  return (
    <Confirmation
      {...props}
      show={clicked}
      onClose={onClose}
    />
  );
}
